export default function VideoSection() {
  return (
    <section className="py-16 md:py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <div className="inline-block bg-teal-100 text-teal-700 px-4 py-2 rounded-full text-sm font-semibold mb-6">
            <i className="ri-play-circle-line mr-2"></i>
            Watch the Introduction
          </div>
          <h2 className="text-4xl font-bold text-gray-900 mb-4">
            Discover the Consistency Paradox
          </h2>
          <p className="text-lg text-gray-700 max-w-3xl mx-auto">
            Watch this compelling introduction to understand how AI's consistency reveals the fundamental flaws in human moral judgment and decision-making.
          </p>
        </div>

        <div className="max-w-5xl mx-auto">
          {/* Video Container */}
          <div className="relative bg-gradient-to-br from-teal-50 to-gray-50 p-6 md:p-8 rounded-2xl shadow-2xl border border-teal-100">
            <div className="relative aspect-video bg-black rounded-xl overflow-hidden shadow-lg">
              <iframe
                width="100%"
                height="100%"
                src="https://www.youtube.com/embed/t03ZKh_g2XQ"
                title="AI Is More Human Than Humans - Book Introduction"
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                allowFullScreen
                className="absolute top-0 left-0 w-full h-full"
              ></iframe>
            </div>

            {/* Video Info */}
            <div className="mt-6 flex flex-wrap items-center justify-between gap-4">
              <div className="flex items-center space-x-3">
                <div className="w-12 h-12 bg-teal-500 rounded-full flex items-center justify-center flex-shrink-0">
                  <i className="ri-video-line text-white text-xl"></i>
                </div>
                <div>
                  <h3 className="font-bold text-gray-900">Video Introduction</h3>
                  <p className="text-sm text-gray-600">AI Is More Human Than Humans</p>
                </div>
              </div>
              
              <a 
                href="#contact" 
                className="inline-block bg-teal-500 hover:bg-teal-600 text-white font-semibold py-3 px-8 rounded-full transition-colors whitespace-nowrap cursor-pointer"
              >
                Get the Book
              </a>
            </div>
          </div>

          {/* Key Takeaways */}
          <div className="grid md:grid-cols-3 gap-6 mt-12">
            <div className="bg-white p-6 rounded-xl shadow-md border-t-4 border-teal-500">
              <div className="w-12 h-12 bg-teal-100 rounded-full flex items-center justify-center mb-4">
                <i className="ri-brain-line text-teal-600 text-xl"></i>
              </div>
              <h4 className="font-bold text-gray-900 mb-2">The Core Paradox</h4>
              <p className="text-gray-600 text-sm">
                Understand why AI's consistency exposes human moral inconsistency
              </p>
            </div>

            <div className="bg-white p-6 rounded-xl shadow-md border-t-4 border-teal-500">
              <div className="w-12 h-12 bg-teal-100 rounded-full flex items-center justify-center mb-4">
                <i className="ri-bar-chart-line text-teal-600 text-xl"></i>
              </div>
              <h4 className="font-bold text-gray-900 mb-2">Research-Backed</h4>
              <p className="text-gray-600 text-sm">
                Evidence from behavioral economics and AI ethics research
              </p>
            </div>

            <div className="bg-white p-6 rounded-xl shadow-md border-t-4 border-teal-500">
              <div className="w-12 h-12 bg-teal-100 rounded-full flex items-center justify-center mb-4">
                <i className="ri-lightbulb-line text-teal-600 text-xl"></i>
              </div>
              <h4 className="font-bold text-gray-900 mb-2">Practical Impact</h4>
              <p className="text-gray-600 text-sm">
                How this understanding transforms decision-making frameworks
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}